import { FreeSlotTypeFilter } from '@/src/domains/client-booking/constants'
import { SessionTypeFilter } from '@/src/domains/therapist-filters/constants'
import { useTherapistSessionTypeFilter } from '@/src/domains/therapist-filters/hooks/useTherapistSessionTypeFilter'

const freeSlotTypeFilterBySessionTypeFilter: Record<SessionTypeFilter, FreeSlotTypeFilter | null> = {
  [SessionTypeFilter.ALL]: null,
  [SessionTypeFilter.ONLINE]: FreeSlotTypeFilter.ONLINE,
  [SessionTypeFilter.OFFLINE]: FreeSlotTypeFilter.OFFLINE,
  [SessionTypeFilter.HYBRID]: null,
}

const sessionTypeFilterByFreeSlotTypeFilter: Record<FreeSlotTypeFilter, SessionTypeFilter> = {
  [FreeSlotTypeFilter.ONLINE]: SessionTypeFilter.ONLINE,
  [FreeSlotTypeFilter.OFFLINE]: SessionTypeFilter.OFFLINE,
}

export const useFreeSlotTypeQueryFilter = () => {
  const { type, rawType, handleTypeFilter } = useTherapistSessionTypeFilter()

  const pushFilter = (value: FreeSlotTypeFilter | null) => {
    handleTypeFilter(value === null ? SessionTypeFilter.ALL : sessionTypeFilterByFreeSlotTypeFilter[value])
  }

  return {
    rawFilter: rawType,
    filter: freeSlotTypeFilterBySessionTypeFilter[type],
    pushFilter,
  }
}
